const initSlider = (container) => {
  const slider = container.querySelector('.activity-slider');
  const sliderArrows = container.querySelector('.activity-slider-arrows');
  const arrowLeft = container.querySelector('.arrow');
  const arrowRight = container.querySelector('.arrow-right');
  let scrollAmount = 0;

  const bindEvents = () => {
    arrowLeft?.addEventListener('click', () => horizontalScroll('back'));
    arrowRight?.addEventListener('click', horizontalScroll);
    window.addEventListener('resize', renderArrows);
    slider.addEventListener('scroll', renderArrows);
  };

  const horizontalScroll = (direction) => {
    scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction === 'back') {
        slider.scrollLeft -= 70;
      } else {
        slider.scrollLeft += 70;
      }

      setArrowsFromScrollStates();
      scrollAmount += 70;
      if (scrollAmount >= 500) {
        window.clearInterval(slideTimer);
      }
    }, 27);
  };

  const renderArrows = () => {
    if (slider.scrollWidth > slider.clientWidth) {
      setArrowsFromScrollStates();
      sliderArrows?.classList.add('d-lg-flex');
    } else {
      sliderArrows?.classList.remove('d-lg-flex');
      arrowLeft?.classList.add('disabled');
      arrowRight?.classList.add('disabled');
    }
  };

  const setArrowsFromScrollStates = () => {
    if (slider.scrollWidth - 1 < slider.clientWidth + slider.scrollLeft) {
      arrowRight?.classList.add('disabled');
    } else {
      arrowRight?.classList.remove('disabled');
    }
    if (slider.scrollLeft === 0) {
      arrowLeft?.classList.add('disabled');
    } else {
      arrowLeft?.classList.remove('disabled');
    }
  };

  bindEvents();
  renderArrows();
};

document.addEventListener('DOMContentLoaded', function () {
  Array.from(document.querySelectorAll('.activity-slider-wrapper')).forEach((container) => {
    initSlider(container);
  });
});
